import { EnvironmentSettings } from "./environment.model";

export const environment: EnvironmentSettings = {
	development: true,
	mock: false,
	staging: false,
	apiEndPoint: "https://signupapi-dev.ad.internal/api/",
	production: false,
	envName: "dev",
	orgType: 2,
	brand: "Dodo",
	source: "DODOWEB",
	appName: "sales_ext_dodo",
	resellerIdParamName: "resellerid",
	promoDiscountCodeParamName: "promo_code",
	promoDiscountCodeParamNameMobile: "p_code",
	lookupDataLocation: "./data",
	features: {
		dollar5Change: false,
	},
	dev: {
		apiHost: "https://signupapi-dev.ad.internal",
		durpalApiHost: "https://gamma.nonprod.dodo.com",
		navLinkHost: "https://www.dodo.com",
		enableBundling: false,
		allowTestPage: true,
		authOption: "local",
		auth0Config: {
			clientId: "1KM7xCIqE93CWNqLvAQ8ysmQdF4RGu1Y",
			domain: "sales-dev.au.auth0.com",
			callbackUrl: "/dealer/auth0-callback",
			audience: "https://onlinesalesexp.api.vocus.com.au",
			appMetaData: "https://signup.dodo.com/app_metadata"
		},
		recaptchaSiteKey: "6LcUYcYkAAAAAHMtwcq9mfEMrVZoInKXvWObio9g",
		callbackUrl: "https://dev.dodo.com/get-call-back",
		hfcCallbackUrl: "https://dev.dodo.com/hfc-get-call-back",
		rqstCallbackUrl: "https://dev.dodo.com/get-call-back?offer_id=2234",
		myDodoWebsiteHost: "https://mydodo-dev.nonprod-vcms.com",
	},
	envConfigName: {
		env: "dev",
		build: "0.0.0",
	},
	muleSoftApiHost:
		"https://retail-nonprod.api.vocus.com.au/dev/exp-onlinesales/api/v1/",
	muleSoftMatchRegex: "exp-onlinesales",
	clientId: "ef15541a13e944598f31da7095c47b82",
	clientSecret: "7c8a1333feBD4c5A886107f6e17a30e6",
	selfServeApiHost:
		"https://retail-nonprod.api.vocus.com.au/dev/exp-selfserve/api/v1/",
	selfServeClientId: "7ba0ddb06cb04c0f9aec1a9acc76f2ac",
	selfServeClientSecret: "1dfcc17d024A4226981C50965C8c584E",
	isOPInternetHotlist: false,
	loggingApiHost:
		"https://pntj2bwdj4.execute-api.ap-southeast-2.amazonaws.com/non-prod/loggerAPI",
	loggingApiKey: "IQe4bvnRPh8mHcTyGK2Uj4JhTldyqzGSalWWM3dA",
	ipChecker: "https://api.ipify.org?format=json"
};
